import { getRequest, postRequest, patchRequest } from "../utils/axios";

export const projectPlansService = {
  list: (onSuccess, onError) => getRequest("/api/v1/project-plans/", onSuccess, onError),
  getCurrent: (onSuccess, onError) => getRequest("/api/v1/project-plans/current/", onSuccess, onError),
  analyze: (tableHashes, brief, onSuccess, onError, options = {}) =>
    postRequest(
      "/api/v1/project-plans/analyze/",
      {
        tables: tableHashes,
        brief: brief || "",
        ...(options.pre_approve ? { pre_approve: true } : {}),
        ...(options.auto_publish ? { auto_publish: true } : {}),
      },
      onSuccess,
      onError
    ),
  suggestBrief: (tables, onSuccess, onError) =>
    postRequest(
      "/api/v1/project-plans/suggest-brief/",
      { tables },
      onSuccess,
      onError
    ),
  update: (hash, data, onSuccess, onError) =>
    patchRequest(`/api/v1/project-plans/${hash}/`, data, onSuccess, onError),
  approve: (hash, data, onSuccess, onError) =>
    postRequest(`/api/v1/project-plans/${hash}/approve/`, data || {}, onSuccess, onError),
  reject: (hash, onSuccess, onError) =>
    postRequest(`/api/v1/project-plans/${hash}/reject/`, {}, onSuccess, onError),
};
